import cx from 'classnames';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import config from '@plone/volto/registry';

import styles from './styles.module.css';
import { defineMessages, useIntl } from 'react-intl';
import type { QubicaContactCardsStyleProps, QubicaViewProps } from './utils';

const QubicaBaseCard = (
  props: QubicaViewProps &
    QubicaContactCardsStyleProps & { main_base?: boolean },
) => {
  const intl = useIntl();
  const Image = config.getComponent('Image').component;

  const { content, bg, main_base = true } = props;
  return (
    <div
      className={cx(styles.qubicaBaseCard, {
        [styles.whiteBg]: bg === 'white',
        [styles.grayBg]: bg === 'gray',
      })}
    >
      <div className={styles.qubicaBaseCardText}>
        <div>
          {main_base
            ? (content.base_title || content.title) && (
                <h4 className={styles.qubicaBaseCardTitle}>
                  {content.base_title ?? content.title}
                </h4>
              )
            : content.base_title_2 && (
                <h4 className={styles.qubicaBaseCardTitle}>
                  {content.base_title_2}
                </h4>
              )}
          {content[main_base ? 'address' : 'address_2'] && (
            <div>{content[main_base ? 'address' : 'address_2']}</div>
          )}
          {(content[main_base ? 'zipcode' : 'zipcode_2'] ||
            content[main_base ? 'city' : 'city_2']) && (
            <div>
              {content[main_base ? 'zipcode' : 'zipcode_2'] && (
                <span>{content[main_base ? 'zipcode' : 'zipcode_2']}</span>
              )}
              {content[main_base ? 'zipcode' : 'zipcode_2'] &&
                content[main_base ? 'city' : 'city_2'] &&
                ' '}
              {content[main_base ? 'city' : 'city_2'] && (
                <span>{content[main_base ? 'city' : 'city_2']}</span>
              )}
            </div>
          )}
          {content[main_base ? 'phone' : 'phone_2'] && (
            <div>Phone: {content[main_base ? 'phone' : 'phone_2']}</div>
          )}
          {content[main_base ? 'mobile' : 'mobile_2'] && (
            <div>Mobile: {content[main_base ? 'mobile' : 'mobile_2']}</div>
          )}
          {content[main_base ? 'fax' : 'fax_2'] && (
            <div>Fax: {content[main_base ? 'fax' : 'fax_2']}</div>
          )}
          {content.email && (
            <div>
              Email:
              <a href={`mailto:${content.email}`}>{content.email}</a>
            </div>
          )}
          {content[main_base ? 'state' : 'state_2'] && (
            <div>{content[main_base ? 'state' : 'state_2']}</div>
          )}
        </div>

        {content?.localsite && (
          <div className={styles.qubicaBaseCardCTAContainer}>
            <UniversalLink
              href={content.localsite}
              openLinkInNewTab={true}
              className={styles.qubicaBaseCardCTA}
            >
              {intl.formatMessage(messages.contact_cta_label)}
            </UniversalLink>
          </div>
        )}
      </div>
      <div className={styles.qubicaBaseCardImageContainer}>
        <Image
          imageField={content.map_image ? 'map_image' : 'image'}
          item={content}
          alt={content.title}
          className={styles.cardImage}
        />
      </div>
    </div>
  );
};

export default QubicaBaseCard;

const messages = defineMessages({
  contact_cta_label: {
    id: 'contact_cta_label',
    defaultMessage: 'Contact',
  },
});
